import { Box, Typography } from '@mui/material';
import { Job } from '../../types/job';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTranslation } from 'react-i18next';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import grey from '@mui/material/colors/grey';

export const JobOppurtunityRow = ({ job }: { job: Job }) => {
  const styles = {
    container: {
      paddingY: '0.5rem',
      paddingX: '1rem',
      gap: '1rem',
      marginY: '0.3rem',
      width: '100%',
      backgroundColor: grey[100],
      borderRadius: '0.5rem',
      display: 'flex',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    item: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
    },
    text: {
      textAlign: 'left',
      paddingLeft: '0.3rem',
      fontSize: {
        xs: '0.8rem',
        sm: '1rem',
      },
    },
  };
  const jobTags = job.tags.split(',').map((tag) => tag.trim());

  return (
    <Box sx={styles.container}>
      {jobTags &&
        jobTags.map((jobTag, index) => (
          <Grid2 xs={4} key={index}>
            <Box sx={styles.item}>
              <CheckCircleIcon color="success" />
              <Typography sx={styles.text} color={'#454F63'}>
                {jobTag}
              </Typography>
            </Box>
          </Grid2>
        ))}
    </Box>
  );
};
